/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type TradeFirmStatusEnum = "ACTIVE" | "INACTIVE" | "PENDING" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type InviteColleagues_tradeFirm$ref: FragmentReference;
export type InviteColleagues_tradeFirm = {|
  +firmStatus: ?TradeFirmStatusEnum,
  +$refType: InviteColleagues_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "InviteColleagues_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firmStatus",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6a4121e8653fecd23aa8d301eb1449c0';
module.exports = node;
